<template>
  <!-- _________________________ FORGOT PASSWORD _________________________ -->
  <div id="forgot-password-div">
    <div class="d-flex align-items-center mb-2 page-title" @click="showLoginView">
      <div class="header-button" >
        <i class="ph-custom ph-caret-left-fill"/>
      </div>
      <h1 class="page-title  ml-1">{{ $t('forgotTitle') }}</h1>
    </div>

    <h2 v-if="!sendWithSuccess" class="page-subtitle mt-3">
      {{ $t('forgotSubtitle') }}
    </h2>

    <form class="mt-4" @submit.stop.prevent="handleForgotSubmit">

      <b-alert :show="ui.showError" variant="danger">
        {{ ui.showErrorMessage }}
        <a class="error-danger-link" v-if="ui.showValidateAccountError" href="#" v-on:click="resendValidateAccountMail">
          {{ $t('account.not.validated.resent.error') }}
        </a>
      </b-alert>

      <b-alert :show="ui.showResendValidateAccountMailSuccess" variant="success">
        {{ $t('ResendValidateAccountMail.success') }}
      </b-alert>

      <b-alert :show="tokenIsExpired" variant="danger">
        {{ $t('token.expired.error') }}
      </b-alert>

      <div v-if="sendWithSuccess&&!ui.showValidateAccountError" class="confirm-email mt-2">
        <check-icon class="check-icon-successful"></check-icon>
        <p class="text-successful ml-2">{{ this.$t('user.mail.send') }}</p>
      </div>
      <div v-if="sendWithSuccess&&!ui.showValidateAccountError" class="mt-3 ">
        <p v-html="$t('Reset.password.mail.resent', {mail: this.form.username.value})"></p>
      </div>

      <b-form-group v-show="!sendWithSuccess"
                    :label="$t('forgotCredential')"
                    label-for="username-input">
        <b-form-input
          id="username-input"
          v-model="form.username.value"
          required
          type="email"
          @keydown="hideMessages">
        </b-form-input>
      </b-form-group>

      <div class="mt-4">
        <b-button :disabled="timer > 0" type="submit" class="btn-block bold-text" variant="secondary">
          {{ timer > 0 ? $t('user.resend.mail.timer', {timer: this.timer}) : $t('forgotButtonText') }}
        </b-button>
      </div>

    </form>

  </div>
</template>

<script>

import api from '../../../services/api'

export default {

  name: 'ForgotPasswordComponent',
  props: {
    email: {
      type: String,
      default: "",
      required: false
    },
    tokenIsExpired: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      form: {
        username: {
          value: null
        }
      },
      ui: {
        showError: false,
        showErrorMessage: this.$i18n.t('internal.server.error'),
        showValidateAccountError: false,
        showResendValidateAccountMailSuccess: false,
        showForgotSuccess: false
      },
      isSending: false,
      timer: 0,
      sendWithSuccess: false
    }
  },

  watch: {
    timer: function (newValue) {
      if (newValue <= 110) {
        this.sendWithSuccess = false
      }
    },
  },
  emits: ['showLoginView'],


  mounted() {
    if (this.email) {
      this.form.username.value = this.email
    }
  },

  methods: {

    startTimer() {
      this.timer = 10;
      const interval = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    },

    handleForgotSubmit() {
      //resendMail
      if (this.timer > 0) {
        return
      }

      if (this.isSending) {
        return
      }
      this.isSending = true

      this.hideError()
      let formData = new FormData()
      formData.append('username', this.form.username.value.trim())

      api({
        method: 'POST',
        url: `/forgotPassword/sendResetPasswordMail`,
        data: formData
      })
        .then(() => {
          this.ui.showForgotSuccess = true
          this.sendWithSuccess = true
          this.startTimer()
          this.isSending = false
        })
        .catch((error) => {
          this.isSending = false
          if (!error.response) {
            console.log("error", error)
          }
          if (error.response && error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error.email')
            this.ui.showError = true
          }
          if (error.response && error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
            if (error.response.data.message === 'account.not.validated.error') {
              this.ui.showValidateAccountError = true
            }
          }
          if (error.response && error.response.status === 423) {
            this.ui.showErrorMessage = this.$i18n.t('account.locked.error')
            this.ui.showError = true
          }
        })
    },

    resendValidateAccountMail() {
      this.hideError()

      let formData = new FormData()
      formData.append('username', this.form.username.value.trim())

      api({
        method: 'POST',
        url: `/authentication/resendValidateAccountMail`,
        data: formData
      })
        .then(() => {
          this.ui.showResendValidateAccountMailSuccess = true
        })
        .catch((error) => {
          if (!error.response) {
            console.log("error", error)
          }
          if (error.response && error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error.email')
            this.ui.showError = true
          }
          if (error.response && error.response.status === 500) {
            this.ui.showErrorMessage = this.$i18n.t('internal.server.error')
            this.ui.showError = true
          }
        })
    },

    showLoginView() {
      this.$emit('showLoginView')
    },

    hideError() {
      this.ui.showError = false
      this.ui.showErrorMessage = null
      this.ui.showValidateAccountError = false
      this.tokenIsExpired = false
    },

    hideMessages() {
      this.ui.showResendValidateAccountMailSuccess = false
      this.ui.showForgotSuccess = false
      this.hideError()
    }

  }

}

</script>

<style scoped>
.confirm-email {
  display: flex;
  align-items: center;
  padding: 0.5em 0.5em 0.5em 0;
}

.chevron-color {
  color: var(--main-yellow-medium)
}

.success-mail {
  background: #EDFCF0 0% 0% no-repeat padding-box;
  border: 2px solid #00A01F;
  border-radius: 4px;
  opacity: 1;
  min-height: 2em;
}

.check-icon-successful {
  color: #1E8C9E;
  margin-left: 0.5em;
}


.send-email {
  color: #000122;
  text-align: left;
  letter-spacing: 0px;
  font-size: 16px;
}

.header-button {
  background-color: var(--main-yellow-medium);
  border-radius: 10px;
  height: 32px;
  width: 32px;
  min-width: 36px;
  margin-right: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  color : var(--main-black-medium)
}

.header-button:hover {
  cursor: pointer;
  background-color: var(--main-yellow-dark);
}

</style>



// WEBPACK FOOTER //
// src/views/auth/components/ForgotPasswordComponent.vue